module.exports = __webpack_public_path__ + "static/pat-70496286d0823046d9ee26445c424bb1.svg";